<div matDialogTitle class="roadside-assistance-marketing__header">
  <h1 class="roadside-assistance-marketing__header__title" i18n="@@S_RSA_TILE">Roadside Assistance</h1>
  <button mat-icon-button matDialogClose class="roadside-assistance-marketing__header__close"><mat-icon>close</mat-icon></button>
</div>

<div matDialogContent class="roadside-assistance-marketing__content">
  <div>
    <img src="./assets/images/rsa/rsa-marketing-modal.png" alt="New in Work" width="565" height="236" />
  </div>
  <div class="rsa-content">
    <span class="rsa-content-item" i18n="@@S_RSA_MARKETING_MODAL_BODY_BENEFITS"
      >Quick, cost-effective coverage, whether you need fuel delivery or have a flat tire.</span
    >
    <span class="rsa-content-item" i18n="@@S_RSA_MARKETING_MODAL_BODY_ACTION"
      >See how easy and cost-effective Roadside Assistance can be for you and your drivers.</span
    >
  </div>
</div>

<div matDialogActions class="roadside-assistance-marketing__actions">
  <button
    mat-flat-button
    color="accent"
    id="btn-rsa-marketing-close"
    a7s-id="live-map-vehicle-contextual-menu-rsa-modal-learn-more"
    i18n="@@S_LEARN_MORE"
    class="roadside-assistance-marketing__actions__buttons__save btn-uppercase vzc-small"
    (click)="onLearnMoreClick()"
  >
    LEARN MORE
  </button>
</div>
